// @flow
import { colors } from '../config';
import type { BackgroundColors } from '../types';

export default function sanitizePrismicBackgroundColors(
  color: ?string,
): BackgroundColors | void {
  return typeof color === 'string' && colors[color] ? colors[color] : undefined;
}
